import * as React from 'react';

import {LinkCard} from 'shells/card/link-card';
import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import type {OnboardingModuleType} from 'nutshell-graphql-types';

import {CurtainModal} from '../../../onboarding/lifting-of-the-curtain/curtain-modal';
import {OpenableModals} from '../../../openable-modals/openable-modals';
import {useOpenableModal} from '../../../openable-modals/use-openable-modal';

import {appHistory} from '../../../../history';

import {getLearnMoreItems} from './helpers';
import type {LearnMoreItem} from './types';

type Props = {
    moduleType: OnboardingModuleType;
};

export function LearnMoreInfo(props: Props) {
    const [isEssentialsModalOpen, setIsEssentialsModalOpen] = React.useState<boolean>(false);

    const {onOpen: onOpenVisitorIqOnboardingModal} = useOpenableModal(
        OpenableModals.VISITOR_IQ_ONBOARDING_MODAL
    );
    const {onOpen: onOpenEngagementBarOnboardingModal} = useOpenableModal(
        OpenableModals.ENGAGEMENT_BAR_ONBOARDING_MODAL
    );
    const {onOpen: onOpenBroadcastInfoModal} = useOpenableModal(
        OpenableModals.BROADCAST_INFO_MODAL
    );
    const {onOpen: onOpenNewsletterInfoModal} = useOpenableModal(
        OpenableModals.NEWSLETTER_INFO_MODAL
    );
    const {onOpen: onOpenDripSequenceInfoModal} = useOpenableModal(
        OpenableModals.DRIP_SEQUENCE_INFO_MODAL
    );
    const {onOpen: onOpenPipelineOnboardingModal} = useOpenableModal(
        OpenableModals.BOARD_ONBOARDING_MODAL
    );
    const {onOpen: onOpenQuotesInvoicesOnboardingModal} = useOpenableModal(
        OpenableModals.QUOTES_AND_INVOICES_ONBOARDING_MODAL
    );

    const learnMoreItems: Array<LearnMoreItem> = getLearnMoreItems(
        props.moduleType,
        appHistory,
        setIsEssentialsModalOpen,
        onOpenVisitorIqOnboardingModal,
        onOpenEngagementBarOnboardingModal,
        onOpenBroadcastInfoModal,
        onOpenNewsletterInfoModal,
        onOpenDripSequenceInfoModal,
        onOpenPipelineOnboardingModal,
        onOpenQuotesInvoicesOnboardingModal
    );

    return (
        <>
            <Stack spacing={24}>
                {learnMoreItems.map((item) => (
                    <LinkCard
                        key={item.description}
                        onClick={item.onClick}
                        hasBorder={false}
                        hasShadow={false}
                        preventUnderline={true}
                        as='div'
                    >
                        <Stack
                            spacing={16}
                            isHorizontal={true}
                            key={item.description}
                            // @ts-expect-error
                            alignContent='left'
                        >
                            <div className='flex-shrink'>
                                <item.icon size={20} wrapWithDiv={false} />
                            </div>
                            <Stack spacing={4}>
                                <Body color='dark' isBold={true} wrapAnywhere={true}>
                                    {item.description}
                                </Body>
                                <Link
                                    onClick={(e: React.MouseEvent) => {
                                        e.stopPropagation();
                                        item.onClick();
                                    }}
                                    variant='primary'
                                    size='small'
                                >
                                    {item.buttonText ?? 'Learn more'}
                                </Link>
                            </Stack>
                        </Stack>
                    </LinkCard>
                ))}
            </Stack>
            {isEssentialsModalOpen && (
                <CurtainModal onClose={() => setIsEssentialsModalOpen(false)} />
            )}
        </>
    );
}
